import React, { Component } from 'react';
import DateFilter from '../../../Components-2025/dashboard/DateFilter';
import PerformanceGraph from '../../../Components-2025/dashboard/PerformanceGraph';
import ProgressBar from '../../../Components-2025/dashboard/ProgressBar';
import TabList from '../../../Components-2025/dashboard/TabList';
import ComponentHeader from '../../../common/ComponentHeader';
import graphDataCalculator from '../../../common/graphDataCalculator';
import { messages } from '../../../common/messages';
import {
  answeredCountKey,
  attemptedCountKey,
  chapterNameKey,
  notesStatsTableNameKey,
  notesTableNameKey,
  performanceGraphUserAnsweredCountKey,
  performanceGraphUserAttemptedCountKey,
  questionStatsTableNameKey,
  questionTableNameKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import tabList from './tabList';
import AppRoutes from '../../config/AppRoutes';
import EmailResubscribe from '../../../components/EmailResubscribe';
import { nextAwareRoute } from '../../../common/cfa1NextRoutes';

/* eslint-disable*/

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPerformanceGraphLoader: true,
      usersBarGraphData: [],
      totalUsersBarGraphData: [],
      barLabelPart1: [],
      //^ progress bar state stated here
      questionProgressBarData: [],
      questionProgressTables: null,
      isQuestionProgressBarLoader: true,
      notesProgressBarData: [],
      isNotesProgressBarLoader: true,
      startDate: '',
      endDate: '',
    };
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //* ============================{{ COMPONENT DID MOUNT START HERE }}==========================================
  async componentDidMount() {
    const { startDate, endDate } = this.state;
    this.getUserPerformanceBarGraph(startDate, endDate, );
    this.getTotalUsersPerformanceBarGraph(startDate, endDate);
    this.getQuestionProgressBar(startDate, endDate);
    this.getNotesProgressBar(startDate, endDate);
  }
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================

  //*=========================={{ PERFORMANCE GRAPH FUNCTION START HERE }}======================================
  getUserPerformanceBarGraph = async (formattedStartDate = '', formattedEndDate = '') => {
    this.setState({ isPerformanceGraphLoader: true });

    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    const result = await apiServiceProvider['getUserPerformanceBarGraph'](data);
    if (result.success) {
      const usersBarGraphData = await graphDataCalculator(
        result.userAttemptedAndAnsweredCount,
        performanceGraphUserAttemptedCountKey,
        performanceGraphUserAnsweredCountKey,
      );
      
      this.setState({ usersBarGraphData });
    }
    this.setState({ isPerformanceGraphLoader: false });
  };

  getTotalUsersPerformanceBarGraph = async (
    formattedStartDate = '',
    formattedEndDate = '',
  ) => {
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    const result = await apiServiceProvider['getTotalUsersPerformanceBarGraph'](data);
    if (result.success) {
      let totalUsersBarGraphData;
      if (formattedStartDate && formattedEndDate) {
        totalUsersBarGraphData = await graphDataCalculator(
          result.attemptedCount,
          performanceGraphUserAttemptedCountKey,
          performanceGraphUserAnsweredCountKey,
        );
      } else {
        totalUsersBarGraphData = await graphDataCalculator(
          result.attemptedCount,
          attemptedCountKey,
          answeredCountKey,
        );
      }
      const barLabel = await result.attemptedCount.map(chapters => {
        return chapters[chapterNameKey].substring(0, 14);
      });
      this.setState({
        totalUsersBarGraphDataPart: totalUsersBarGraphData,
        barLabelPart: barLabel,
      });
    }
    this.setState({isPerformanceGraphLoader: false });
  };
  //*=========================={{ PERFORMANCE GRAPH FUNCTION ENDED HERE }}======================================

  //*================================{{QUESTION AND NOTES PROGRESS BAR FUNCTIONS START HERE }}====================================
  getQuestionProgressBar = async (formattedStartDate = '', formattedEndDate = '') => {
    this.setState({isQuestionProgressBarLoader: true });
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
    const result = await apiServiceProvider[`fetchQuestionProgressBar`](data);
    if (result.success) {
      this.setState({
        questionProgressBarData: result.chapters,
        questionProgressTables: result.tables,
        isQuestionProgressBarLoader: false,
      });
    }
  };
  getNotesProgressBar = async (formattedStartDate = '', formattedEndDate = '', level) => {
    this.setState({ isNotesProgressBarLoader: true });
    const data = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      level,
    };
    const result = await apiServiceProvider[`fetchNotesProgressBar`](data);
    if (result.success) {
      this.setState({
        notesProgressBarData: result.chapters,
        isNotesProgressBarLoader: false,
      });
    }
  };
  viewAllQuestion = () => {
    this.context.router.push({
      pathname: nextAwareRoute(AppRoutes.CFA1_2025_DASHBOARD_VIEW_QUESTIONS),
    });
  };

  //*============================={{QUESTION AND NOTES PROGRESS BAR FUNCTIONS ENDED HERE }}======================================
  render() {
    const { state } = this;
    const {
      barLabelPart,
      isPerformanceGraphLoader,
      usersBarGraphData,
      totalUsersBarGraphDataPart,
      questionProgressBarData,
      questionProgressTables,
      isQuestionProgressBarLoader,
      notesProgressBarData,
      isNotesProgressBarLoader,
    } = state;
    // Notes-progress rows come back keyed by the notes table name, which differs per exam year
    // (cfa1_2025_notes for 2025/2026, cfa1_2027_notes for 2027). The static notesTableNameKey
    // only matches the 2025 table, so for a year that uses a different notes table the ProgressBar
    // would read undefined keys and render an empty bar. Resolve the matching key per selected exam.
    const selectedExam = localStorage.getItem('selectedmenu');
    const notesModelKey =
      selectedExam === 'cfa_2027' ? 'cfa1_2027_notes' : notesTableNameKey;
    // Saved/Reported rows come back keyed by the singular per-year association alias. For 2027
    // the notes AND videos models are cloned (cfa1_2027_notes / cfa1_2027_videos), so their
    // aliases differ from the 2025 ones hardcoded in tabList (cfa1_2025_note / cfa1_2025_video).
    // Without remapping, the topic text reads undefined ("Notes ID: N" / "Video Id: N" with no
    // title). Remap the affected tabs' saveItemTableName for the selected exam.
    // For 2027 the question and CBT-question models are cloned too (cfa1_2027_questions /
    // cfa1_2027_cbt_questions), so the report/saved rows key their included topic by the 2027
    // association alias (cfa1_2027_question / cfa1_2027_cbt_question) instead of the 2025 ones the
    // tabList hardcodes. Without remapping, the topic reads undefined and the Edit-report click
    // crashes on the missing nested object.
    const aliasFor2027 = {
      cfa1_2025_note: 'cfa1_2027_note',
      cfa1_2025_video: 'cfa1_2027_video',
      question: 'cfa1_2027_question',
      cfa_cbt_question: 'cfa1_2027_cbt_question',
    };
    const yearAwareTabList =
      selectedExam === 'cfa_2027'
        ? tabList.map((tab) =>
            aliasFor2027[tab.saveItemTableName]
              ? { ...tab, saveItemTableName: aliasFor2027[tab.saveItemTableName] }
              : tab,
          )
        : tabList;
    return (
      <div className='animated fadeIn'>
        <EmailResubscribe/>
          <div className='row'>
            <div className='col-sm-12 mt-1'>
              {/*//^====================={{ DASHBOARD HEADER START HERE }}===================== */}
              <ComponentHeader title={`CFA Level I ${messages.DASHBOARD}`}>
                <button
                  className='btn btn-primary pointer_class'
                  onClick={this.viewAllQuestion}>
                  {messages.DETAILED_STATS}
                </button>
              </ComponentHeader>
              {/*//^====================={{ DASHBOARD HEADER ENDED HERE }}===================== */}
            </div>
            <div className='col-sm-8'>
              {/*//^====================={{ DATE FILTER START HERE }}===================== */}
              <DateFilter
                getUserBarGraph={this.getUserPerformanceBarGraph}
                getTotalUsersBarGraph={this.getTotalUsersPerformanceBarGraph}
              />
              {/*//^====================={{ DATE FILTER ENDED HERE }}===================== */}
              {/*//^====================={{ PERFORMANCE BAR GRAPH START HERE }}===================== */}
              <PerformanceGraph
                barLabel={barLabelPart}
                headText={messages.PERFORMANCE}
                tooltipContent={messages.SEPARATE_YOUR_RESULT}
                tooltipPlace='left'
                performanceGraphLoader={isPerformanceGraphLoader}
                usersBarGraphData={usersBarGraphData}
                totalUsersBarGraphData={totalUsersBarGraphDataPart}
              />
              {/*//^====================={{ PERFORMANCE BAR GRAPH ENDED HERE }}===================== */}
              <TabList
                section='favAPIService'
                exam='cfa1_2025'
                TabHeader={messages.MY_SAVED_ITEM_WITH_FLASH_CARD}
                apiServiceProvider={apiServiceProvider}
                tabList={yearAwareTabList}
              />
              <TabList
                section='reportAPIService'
                exam='cfa1_2025'
                TabHeader={messages.MY_REPORTS}
                apiServiceProvider={apiServiceProvider}
                tabList={yearAwareTabList}
              />
            </div>
            {/*//^======================={{ QUESTION AND NOTES PROGRESS BAR START HERE }}===================== */}
            <div className='col-lg-4'>
              <ProgressBar
                headerName={messages.QUESTION_PROGRESS}
                ProgressBarData={questionProgressBarData}
                progressBarLoader={isQuestionProgressBarLoader}
                ProgressBarTables={questionProgressTables || {
                  questionModel: questionTableNameKey,
                  questionStatsModel: questionStatsTableNameKey,
                }}
              />
              <ProgressBar
                headerName='Notes Progress'
                ProgressBarData={notesProgressBarData}
                progressBarLoader={isNotesProgressBarLoader}
                countKey={'notesCount'}
                ProgressBarTables={{
                  questionModel: notesModelKey,
                  questionStatsModel: notesStatsTableNameKey,
                }}
              />
            </div>
            {/*//^======================={{ QUESTION AND NOTES PROGRESS BAR ENDED HERE }}===================== */}
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Dashboard/index.jsx